import { render, staticRenderFns } from "./ContentBlockEmbedSimple.vue?vue&type=template&id=31343afc&"
import script from "./ContentBlockEmbedSimple.vue?vue&type=script&lang=js&"
export * from "./ContentBlockEmbedSimple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports